import { makeCommunicationActionCreator } from 'shared/utils/communication/actions/makeCommunicationActionCreator'
import dayjs from 'dayjs'
import { ICashbackHistoryFilters, IConvertedBonusHistory, IGetBonusHistoryFilters } from 'shared/models/BonusSystem'

export const getBonusHistory = makeCommunicationActionCreator({
  loading: '@bonusHistory/GET_BONUS_HISTORY_LOADING',
  success: '@bonusHistory/GET_BONUS_HISTORY_SUCCESS',
  error: '@bonusHistory/GET_BONUS_HISTORY_ERROR',
  reset: '@bonusHistory/GET_BONUS_HISTORY_RESET',
})<IGetBonusHistoryFilters, IConvertedBonusHistory>(
  async ({
    deps: {
      extra: { api },
    },
    payload,
  }) => {
    const data = {
      ...payload,
      date_from: payload.date_from ? dayjs(payload.date_from).startOf('day').format('YYYY-MM-DDTHH:mmZ') : undefined,
      date_to: payload.date_to ? dayjs(payload.date_to).endOf('day').format('YYYY-MM-DDTHH:mmZ') : undefined,
      ordering: '-date',
    }

    const response = await api.bonusSystem.loadBonusHistory(data)
    return response.data
  },
)

export const getCashbackHistory = makeCommunicationActionCreator({
  loading: '@bonusHistory/GET_CASHBACK_HISTORY_LOADING',
  success: '@bonusHistory/GET_CASHBACK_HISTORY_SUCCESS',
  error: '@bonusHistory/GET_CASHBACK_HISTORY_ERROR',
  reset: '@bonusHistory/GET_CASHBACK_HISTORY_RESET',
})<ICashbackHistoryFilters, IConvertedBonusHistory>(
  async ({
    deps: {
      extra: { api },
    },
    payload,
  }) => {
    const data = {
      ...payload,
      date_from: payload.date_from ? dayjs(payload.date_from).startOf('day').format('YYYY-MM-DDTHH:mmZ') : undefined,
      date_to: payload.date_to ? dayjs(payload.date_to).endOf('day').format('YYYY-MM-DDTHH:mmZ') : undefined,
    }

    const response = await api.bonusSystem.loadCashbackHistory(data)
    return response.data
  },
)
